
import { motion } from "framer-motion";
import ContactForm from "./ContactForm";
import ContactInfo from "./ContactInfo";
import LocationMap from "./LocationMap";

const Contact = () => {
  const mapLink = "https://maps.app.goo.gl/BnSdDAxMHSHYuuWU7?g_st=com.google.maps.preview.copy";
  const instagramLink = "https://www.instagram.com/061garagedetailingstudio?igsh=MTZud2lxYWkybmtqcQ%3D%3D&utm_source=qr";
  const facebookLink = "https://www.facebook.com/share/18rLAmAdqC/?mibextid=wwXIfr";

  return (
    <section id="contact" className="section-spacing bg-garage-dark border-t border-garage-gray/20">
      <div className="container-spacing">
        <motion.h2 
          className="section-title text-center" 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Kontakt
        </motion.h2>
        
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 mb-12">
            <div className="order-2 lg:order-1">
              <ContactForm />
            </div>
            <div className="order-1 lg:order-2">
              <ContactInfo 
                mapLink={mapLink}
                instagramLink={instagramLink}
                facebookLink={facebookLink}
              />
            </div>
          </div>
          
          <div className="border-t border-garage-gray/20 pt-12">
            <LocationMap />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
